import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UserVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveUserList = createAsyncThunk<UserVM[], void, { extra: Partial<Dependencies> }>(
  "users/retrieveUserList",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.retrieveUserList();
  },
);
